import React from 'react';
import Layout from "../components/layout";
import {
    Box,
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Grid,
    Paper,
    Typography
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
//import {Link} from "gatsby-theme-material-ui";
import Seo from "../components/seo";
import {useIntl, navigate, Link, FormattedMessage} from "gatsby-plugin-intl"




const useStyles = makeStyles((theme) => ({
    hero: {
        position: "relative",
        overflow: "hidden",
        borderRadius: theme.spacing(3),
        padding: theme.spacing(4, 3),
        color: theme.palette.text.primary,
        background: `linear-gradient(135deg, rgba(53,103,50,0.15), rgba(211,47,47,0.18)), #fff`,
        boxShadow: "0 18px 40px rgba(0,0,0,0.12)",
        marginBottom: theme.spacing(4),
        "&:before": {
            content: '""',
            position: "absolute",
            inset: 0,
            backgroundImage:
                "radial-gradient(circle at 12% 20%, rgba(53,103,50,0.22) 0 120px, transparent 130px)," +
                "radial-gradient(circle at 88% 18%, rgba(211,47,47,0.18) 0 160px, transparent 170px)",
            opacity: 0.55,
            pointerEvents: "none",
        },
    },
    heroInner: {
        position: "relative",
        zIndex: 1,
        display: "grid",
        gap: theme.spacing(2),
    },
    heroBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(1),
        width: "fit-content",
        padding: theme.spacing(0.5, 1.5),
        borderRadius: 999,
        backgroundColor: "rgba(53,103,50,0.12)",
        color: theme.palette.primary.main,
        fontWeight: 600,
    },
    heroTitle: {
        fontWeight: 700,
        letterSpacing: "-0.02em",
    },
    heroSubtitle: {
        maxWidth: 640,
        color: "rgba(0,0,0,0.74)",
    },
    heroActions: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(2),
        alignItems: "center",
    },
    heroPrimary: {
        borderRadius: 999,
        padding: theme.spacing(1.2, 3),
        textTransform: "none",
        fontWeight: 600,
    },
    heroSecondary: {
        borderRadius: 999,
        padding: theme.spacing(1.1, 2.6),
        textTransform: "none",
        fontWeight: 600,
        borderColor: "rgba(0,0,0,0.2)",
    },
    infoCard: {
        borderRadius: theme.spacing(2.5),
        padding: theme.spacing(3),
        background: "#fff",
        boxShadow: "0 16px 32px rgba(0,0,0,0.08)",
        marginBottom: theme.spacing(4),
    },
    infoTitle: {
        fontWeight: 600,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
    },
    cardsWrap: {
        marginTop: theme.spacing(1),
    },
    cardRoot: {
        height: "100%",
        borderRadius: theme.spacing(2),
        overflow: "hidden",
        boxShadow: "0 14px 28px rgba(0,0,0,0.1)",
        transition: "transform 200ms ease, box-shadow 200ms ease",
        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 18px 36px rgba(0,0,0,0.16)",
        },
    },
    cardMedia: {
        height: 220,
    },
    cardContent: {
        minHeight: 150,
    },
    actionItem: {
        ...theme.typography.button,
        backgroundColor: "rgba(53,103,50,0.08)",
        color: theme.palette.primary.main,
        padding: theme.spacing(1, 1.5),
        borderRadius: 999,
        textDecoration: "none",
        fontWeight: 600,
    },
}));
const Index = () => {
    const intl = useIntl();
    const classes = useStyles();




    return (
        <Layout>
            <Seo title={intl.formatMessage({ id: "titulo" })}

                 description={intl.formatMessage({id: "index.description"})}/>
            <Box className={classes.hero}>
                <Box className={classes.heroInner}>
                    <Typography variant="overline" className={classes.heroBadge}>
                        {intl.formatMessage({ id: "index.title" })}
                    </Typography>
                    <Typography variant="h3" className={classes.heroTitle}>
                        {intl.formatMessage({ id: "titulo" })}
                    </Typography>
                    <Typography variant="h6" className={classes.heroSubtitle}>
                        {intl.formatMessage({id: "index.description"})}
                    </Typography>
                    <Box className={classes.heroActions}>
                        <Button
                            className={classes.heroPrimary}
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                                const el = document.getElementById("sectores");
                                if (el) {
                                    el.scrollIntoView({behavior: "smooth", block: "start"});
                                }
                            }}
                        >
                            {intl.formatMessage({id: "Reservar"})}
                        </Button>
                        <Button
                            className={classes.heroSecondary}
                            variant="outlined"
                            href="https://www.acguanacaste.ac.cr/turismo"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {intl.formatMessage({id: "sweb"})}
                        </Button>
                    </Box>
                </Box>
            </Box>

            <Paper className={classes.infoCard}>
                <Typography variant="subtitle1" className={classes.infoTitle}>
                    {intl.formatMessage({ id: "index.covid3" })}
                </Typography>
                <Typography variant="body1" paragraph>
                    {intl.formatMessage({ id: "index.covid" })}
                </Typography>
                <Typography variant="body2">
                    <FormattedMessage
                        id="index.masInfo"
                        values={{
                            a: text => <a href={"https://www.acguanacaste.ac.cr/turismo"} target={"_blank"} rel={"noreferrer"}>{text}</a>,
                        }}
                    />
                    {intl.formatMessage({id: "index.contacto1"})} <a href="mailto:ecoturismo@acguanacaste.ac.cr">ecoturismo@acguanacaste.ac.cr</a>, {intl.formatMessage({id: "telefono"})}: <a href="tel:+50626665051">2666-5051</a>, WhatsApp: <a href="https://api.whatsapp.com/send?phone=50688869510">88869510</a>
                </Typography>
            </Paper>

            <Box id="sectores" className={classes.cardsWrap}>
                <Grid container spacing={4}>


                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            window.open("https://serviciosenlinea.sinac.go.cr/", "_blank")
                        }}>
                            <CardMedia
                                component="img"
                                alt="Reservaciones de ingreso al Pailas, Rincón de la Vieja de ACG"
                                className={classes.cardMedia}
                                image="/images/pailas-cover.jpg"
                                title="Pailas, Rincón de la Vieja de ACG"
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SP"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    <FormattedMessage
                                        id="index.rv"
                                        values={{
                                            a: text => <a href={"https://serviciosenlinea.sinac.go.cr/"}>{text}</a>,
                                        }}
                                    />
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                        <CardActions>
                            <a href="https://serviciosenlinea.sinac.go.cr/" target={"_blank"} rel={"noreferrer"}  color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Comprar"})}
                            </a>
                        </CardActions>
                    </Card>
                </Grid>


                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            navigate("/santa-rosa")
                        }}>
                            <CardMedia
                                component="img"
                                alt="Reservaciones de ingreso al Sector Santa Rosa de ACG "
                                className={classes.cardMedia}
                                image="/images/santa-rosa-cover.jpg"
                                title="Sector Santa Rosa, ACG"
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SR"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {intl.formatMessage({id: "index.srinfo"})}
                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <Link to={"/santa-rosa"} color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Reservar"})}
                            </Link>

                        </CardActions>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            navigate("/naranjo")
                        }}>
                            <CardMedia
                                component="img"
                                alt="Reservaciones de ingreso al Sector Playa Naranjo, Parque Nacional Santa Rosa de ACG "
                                className={classes.cardMedia}
                                image="/images/naranjo.jpg"
                                title="Sector Playa Naranjo, P.N. Santa Rosa, ACG"
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SPN"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {intl.formatMessage({id: "index.naranjo"})}
                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <Link to={"/naranjo"} color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Reservar"})}
                            </Link>

                        </CardActions>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            navigate("/marino")
                        }}>
                            <CardMedia
                                component="img"
                                alt="Reservaciones de ingreso al Sector Marino de ACG"
                                className={classes.cardMedia}
                                image="/images/marino-cover2.jpg"
                                title="Sector Marino, ACG"
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SM"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {intl.formatMessage({id: "index.sminfo"})}

                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <Link to={"/marino"} color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Reservar"})}
                            </Link>

                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            window.open("https://serviciosenlinea.sinac.go.cr/", "_blank")
                        }}>
                            <CardMedia
                                component="img"
                                alt="Reservaciones de ingreso al Sector Santa María, Rincón de la Vieja"
                                className={classes.cardMedia}
                                image="/images/santa-maria-cover.jpg"
                                title="Sector Santa María, ACG"
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SStMa"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    <FormattedMessage
                                        id="index.rv"
                                        values={{
                                            a: text => <a href={"https://serviciosenlinea.sinac.go.cr/"}>{text}</a>,
                                        }}
                                    />

                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <a href="https://serviciosenlinea.sinac.go.cr/" target={"_blank"} rel={"noreferrer"}  color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Comprar"})}
                            </a>

                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            window.location.href = "https://explore-horizontes.com/"
                        }}>
                            <CardMedia
                                component="img"
                                alt={intl.formatMessage({id: "index.horizontes1"})}
                                className={classes.cardMedia}
                                image="/images/horizontes-cover.jpg"
                                title={intl.formatMessage({id: "index.horizontes1"})}
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "EEFH"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {intl.formatMessage({id: "index.hinfo"})}
                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <a href="https://explore-horizontes.com/" target={"_blank"} rel={"noreferrer"} color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Reservar"})}
                            </a>

                        </CardActions>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            navigate("/murcielago")
                        }}>
                            <CardMedia
                                component="img"
                                alt={intl.formatMessage({id: "index.murcielago"})}
                                className={classes.cardMedia}
                                image="/images/murcielago.webp"
                                title={intl.formatMessage({id: "index.murcielago"})}
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SMu"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {intl.formatMessage({id: "index.murcielago"})}
                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <Link to={"/murcielago"} color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Reservar"})}
                            </Link>

                        </CardActions>
                    </Card>
                </Grid>


                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            navigate("/sr-escuelas")
                        }}>
                            <CardMedia
                                component="img"
                                alt="Reservaciones para Centros Educativos, Sector Santa Rosa"
                                className={classes.cardMedia}
                                image="/images/sr-escuelas.jpg"
                                title="Reservaciones para Centros Educativos, Sector Santa Rosa"
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SREsc"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {intl.formatMessage({id: "index.escuelas"})}

                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <Link to={"/sr-escuelas"} color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Reservar"})}
                            </Link>

                        </CardActions>
                    </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.cardRoot}>
                        <CardActionArea onClick={() => {
                            navigate("/junquillal")
                        }}>
                            <CardMedia
                                component="img"
                                alt="Reservaciones de ingreso al Sector Junquillal"
                                className={classes.cardMedia}
                                image="/images/junquillal-cover.jpg"
                                title="Sector junquillal, ACG"
                            />
                            <CardContent className={classes.cardContent}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {intl.formatMessage({id: "SJ"})}
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    {intl.formatMessage({id: "index.jun"})}

                                </Typography>
                            </CardContent>
                        </CardActionArea>

                        <CardActions>
                            <Link to={"/junquillal"} color="primary" className={classes.actionItem}>
                                {intl.formatMessage({id: "Reservar"})}
                            </Link>

                        </CardActions>
                    </Card>
                </Grid>





                </Grid>
            </Box>
        </Layout>
    );
}

export default Index;
